<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

<!-- Assign Users -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="5" class="mb-2"></app-skelitions>
<div class="container" [hidden]="skelition">
  <div class="row filter-bg-color d-flex align-items-center justify-content-center py-4 my-4  flex-wrap">
    <div class="col-md-10 col-12">
      <form class="d-flex flex-column gap-1">
        <label for="email">{{'Add User to Survey'|translator}}</label>
        <div class="d-flex align-items-center justify-content-between">
          <div class="p-fluid v4-p-chip w-100" *ngIf="showMultipleEmails">
            <p-chips [(ngModel)]="userEmails" [addOnBlur]="true" [addOnTab]="true" name="externals"
              [placeholder]="'Multiple users' | translator" #externalMailChips class="p-chipp w-100 v4-p-chip"
              (keydown.enter)="getMultipleUser()" (paste)="handlePaste($event)">
            </p-chips>
          </div>
          <!-- <div #form [formGroup]="emailForm" class="p-fluid w-100">
            <p-autoComplete *ngIf="!showMultipleEmails" field="email" [dropdown]="true" [suggestions]="filteredUsers"
              (completeMethod)="search($event)" [placeholder]="'Email'|translator" (keydown.enter)="getUser()"
              class="w-100" styleClass="w-100" id="email" formControlName="email" />
          </div> -->
          <div class="d-flex gap-2 mx-4 p-2">
            <!-- <button (click)="toggleEmailInput()" class="toggle-button">
              <ng-container *ngIf="showMultipleEmails; else singleEmailIcon">
                <i pTooltip="User" tooltipPosition="top" class="pi pi-user font-22"></i>
              </ng-container>
              <ng-template #singleEmailIcon>
                <i pTooltip="Multiple users" tooltipPosition="top" class="pi pi-users font-22"></i>
              </ng-template>
            </button> -->
          </div>
        </div>
      </form>
    </div>
  </div>

  <p-table *ngIf="users.length > 0" class="manage-tr" [value]="users" [totalRecords]="users.length" dataKey="_id"
    [paginator]="true" [rows]="10" [selectionPageOnly]="true" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 200px">{{ "user name" | translator }}</th>
        <th style="min-width: 200px">{{ "E-mail" | translator }}</th>
        <th style="min-width: 200px">{{ "phone number" | translator }}</th>
        <th style="min-width: 200px">{{ "City" | translator }}</th>
        <th style="min-width: 200px">{{ "Action" | translator }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        <td>
          <strong style="line-height: 1rem">{{
            product?.name?.first +
            " " +
            product?.name?.middle +
            " " +
            product?.name?.last
            }}</strong>
        </td>
        <td>{{ product?.email }}</td>
        <td>{{ product?.phone }}</td>
        <td>
          {{ product.location ? product?.location?.name : "Unspecified" }}
        </td>
        <td>
          <button [pTooltip]="'Remove' | translator" style="
              width: 40px;
              height: 40px;
              border-radius: 100%;
              background-color: red;
              padding: 0.5rem;
              color: white;
              border: none;
            " (click)="confirmDelete(product)">
            <i [ngClass]="'pi pi-trash'"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <app-no-data *ngIf="users.length == 0"></app-no-data>

  <h2 class="mt-3 mb-1">{{ "Unregistered Users" | translator }}</h2>

  <p-table *ngIf="unregisteredUsers.length > 0" class="manage-tr" [value]="unregisteredUsers"
    [totalRecords]="unregisteredUsers.length" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 200px">{{ "E-mail" | translator }}</th>
        <th style="min-width: 200px">{{ "Action" | translator }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td>{{ user }}</td>
        <td>
          <button [pTooltip]="'Remove' | translator" style="
              width: 40px;
              height: 40px;
              border-radius: 100%;
              background-color: red;
              padding: 0.5rem;
              color: white;
              border: none;
            " (click)="confirmDelete(user, true)">
            <i [ngClass]="'pi pi-trash'"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <app-no-data *ngIf="unregisteredUsers.length == 0"></app-no-data>
</div>

<p-toast></p-toast>

<app-footer></app-footer>